<ul class="menubar desktopMenuBar">
  <li>&nbsp;</li>

  @for (menu of menus; track menu) {
    <li
      class="menu"
      (mouseenter)="mouseEnter($event)"
      (mouseleave)="mouseLeave($event)"
      (touchstart)="touchStart($event, menu)"
      (touchend)="touchEnd($event)"
    >
      @if (!menu.path) {
        <a (click)="menuTitleClicked($event)">{{ menu.title }}</a>
      } @else {
        <a [routerLink]="menu.path"
          ><span (click)="menuItemClicked($event)">{{ menu.title }}</span></a
        >
      }
      @if (menu.menus) {
        <ul>
          @for (menuItem of menu.menus; track menuItem) {
            <li class="menuItem">
              <a [routerLink]="menuItem.path"
                ><span (click)="menuItemClicked($event)">{{ menuItem.title }}</span></a
              >
            </li>
          }
        </ul>
      }
    </li>
  }

  <li>&nbsp;</li>
</ul>
